import {
	create,
} from 'zustand'
import {
	persist,
} from 'zustand/middleware'

import {
	LOCAL_STORAGE_KEYS,
} from '@/shared/model/enums'

import type {
	IAuthStoreState,
} from '../../../model/types'

export const useAuthStore = create<IAuthStoreState>()(
	persist((set) => {
		return {
			user:         null,
			isAuth:       false,
			initializing: true,

			finishInitializing: (): void => {
				set({
					initializing: false,
				})
			},
			setUser: (user): void => {
				set({
					user,
					isAuth: Boolean(user),
				})
			},
			logout: (): void => {
				set({
					user:   null,
					isAuth: false,
				})
			},
		}
	}, {
		name: LOCAL_STORAGE_KEYS.AUTH,
	}),
)
